import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ShoppingCart, Search, User, Menu, Sparkles, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Header() {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [mobileMenu, setMobileMenu] = useState(false);
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const submit = (e) => {
    e.preventDefault();
    nav(`/tienda?search=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b-2 border-drelo-ink/10">
      <div className="bg-drelo-ink text-white text-xs overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee py-1.5 font-semibold tracking-wide">
          {Array(2).fill(0).map((_, k) => (
            <span key={k} className="flex">
              <span className="px-6">🔥 OFERTAS RELÁMPAGO HASTA -70%</span>
              <span className="px-6">🚚 ENVÍO GRATIS DESDE $35</span>
              <span className="px-6">🎁 REGALO POR VOLUMEN DE COMPRA</span>
              <span className="px-6">💸 GANA DINERO COMO EMBAJADOR DRELO</span>
              <span className="px-6">⚡ +50.000 CLIENTES FELICES</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-3 md:px-6 py-3 flex items-center gap-3 md:gap-6">
        <button className="md:hidden" onClick={() => setMobileMenu(true)} data-testid="mobile-menu-btn">
          <Menu className="w-6 h-6" />
        </button>

        <Link to="/" className="flex items-center gap-1.5 shrink-0" data-testid="logo-link">
          <span className="bg-drelo-primary text-white w-8 h-8 rounded-lg grid place-items-center font-display font-black text-xl">D</span>
          <span className="font-display font-black text-2xl tracking-tighter">drelo</span>
        </Link>

        <form onSubmit={submit} className="hidden md:flex flex-1 max-w-xl items-center bg-slate-100 rounded-full px-4 py-2.5 border border-transparent focus-within:border-drelo-primary transition-colors">
          <Search className="w-4 h-4 text-drelo-muted" />
          <input
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Busca productos wellness..."
            className="bg-transparent outline-none px-3 w-full text-sm"
            data-testid="search-input"
          />
        </form>

        <div className="flex items-center gap-1 md:gap-3 ml-auto">
          <Link to="/embajadores" className="hidden md:flex items-center gap-1.5 text-sm font-bold text-drelo-primary hover:text-drelo-hover" data-testid="ambassador-nav">
            <Sparkles className="w-4 h-4" /> Embajadores
          </Link>
          {user ? (
            <div className="relative group">
              <button className="flex items-center gap-1.5 text-sm font-semibold px-2 py-1.5" data-testid="account-menu-btn">
                <User className="w-5 h-5" /> <span className="hidden md:inline">{user.name?.split(" ")[0]}</span>
              </button>
              <div className="absolute right-0 top-full hidden group-hover:block bg-white shadow-xl rounded-xl border w-48 py-2">
                <Link to="/cuenta" className="block px-4 py-2 text-sm hover:bg-slate-50" data-testid="account-link">Mi cuenta</Link>
                <Link to="/embajadores" className="block px-4 py-2 text-sm hover:bg-slate-50">Embajadores</Link>
                {user.role === "admin" && <Link to="/admin" className="block px-4 py-2 text-sm hover:bg-slate-50 font-bold text-drelo-primary" data-testid="admin-link">Panel Admin</Link>}
                <button onClick={() => { logout(); nav("/"); }} className="block w-full text-left px-4 py-2 text-sm hover:bg-slate-50 text-drelo-urgency" data-testid="logout-btn">Salir</button>
              </div>
            </div>
          ) : (
            <Link to="/entrar" className="flex items-center gap-1.5 text-sm font-semibold px-2 py-1.5" data-testid="login-nav">
              <User className="w-5 h-5" /> <span className="hidden md:inline">Entrar</span>
            </Link>
          )}
          <button onClick={() => setOpen(true)} className="relative p-2" data-testid="cart-toggle">
            <ShoppingCart className="w-6 h-6" />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 bg-drelo-urgency text-white text-[10px] font-black w-5 h-5 grid place-items-center rounded-full animate-drelo-pulse" data-testid="cart-count">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      <nav className="hidden md:block border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 flex items-center gap-6 text-sm font-semibold h-11">
          <Link to="/tienda" className="text-drelo-urgency hover:opacity-70" data-testid="nav-all">⚡ Ofertas</Link>
          {cats.slice(0, 8).map((c) => (
            <Link key={c} to={`/tienda?category=${encodeURIComponent(c)}`} className="text-drelo-ink/80 hover:text-drelo-primary whitespace-nowrap">{c}</Link>
          ))}
        </div>
      </nav>

      {mobileMenu && (
        <div className="fixed inset-0 z-[60] bg-black/50 md:hidden" onClick={() => setMobileMenu(false)}>
          <div className="bg-white w-72 h-full p-5" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-5">
              <span className="font-display font-black text-xl">Menú</span>
              <button onClick={() => setMobileMenu(false)}><X className="w-6 h-6" /></button>
            </div>
            <form onSubmit={submit} className="flex items-center bg-slate-100 rounded-full px-3 py-2 mb-4">
              <Search className="w-4 h-4 text-drelo-muted" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar..." className="bg-transparent outline-none px-2 w-full text-sm" />
            </form>
            <Link to="/tienda" onClick={() => setMobileMenu(false)} className="block py-2.5 font-bold text-drelo-urgency">⚡ Ofertas</Link>
            {cats.map((c) => (
              <Link key={c} to={`/tienda?category=${encodeURIComponent(c)}`} onClick={() => setMobileMenu(false)} className="block py-2.5 font-semibold">{c}</Link>
            ))}
            <Link to="/embajadores" onClick={() => setMobileMenu(false)} className="block py-2.5 font-bold text-drelo-primary">✨ Embajadores</Link>
          </div>
        </div>
      )}
    </header>
  );
}
